import script from "./Ingress.vue?vue&type=script&setup=true&lang=ts"
export * from "./Ingress.vue?vue&type=script&setup=true&lang=ts"

import "./Ingress.vue?vue&type=style&index=0&id=3dd298f9&scoped=true&lang=scss"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dd298f9"]])

export default __exports__